
Bingo.ContentSwitcher = {};

Bingo.ContentSwitcher.init = function () {
    $('.content-switcher:not(data-content-switcher-initialized)').each((index, item) => {
        if ($(item).attr('data-content-switcher-initialized')) {
            return;
        }
        $(item).attr('data-content-switcher-initialized', true);
        $(item).click(function () {
            Bingo.ContentSwitcher.trigger($(this));
        });
    });
};

Bingo.ContentSwitcher.trigger = function (el) {
    const primaryArea = $(`#${el.data('primary-area-id')}`);
    const secondaryArea = $(`#${el.data('secondary-area-id')}`);
    const body = $('body');
    if (!primaryArea.length || !secondaryArea.length) {
        console.error('Areas for content-switcher are wrongly defined (wrong selectors).');
    }
    const isHidden = secondaryArea.hasClass('mobile-hidden');
    if (!el.data('show-text')) {
        el.data('show-text', el.text());
    }
    const showText = el.data('show-text');
    let hideText;
    if (!el.data('one-way')) {
        hideText = el.data('hide-text');
    } else {
        hideText = el.data('show-text');
    }

    if (isHidden) {
        primaryArea.addClass('mobile-hidden');
        secondaryArea.removeClass('mobile-hidden');
        body.addClass('mobile-map-fullscreen');
        if (window.HubSpotConversations) {
            window.HubSpotConversations.widget.remove();
        }
        el.text(hideText);
        Bingo.Map.reloadAllInstancesIn(`#${el.data('secondary-area-id')}`);
    } else {
        primaryArea.removeClass('mobile-hidden');
        secondaryArea.addClass('mobile-hidden');
        body.removeClass('mobile-map-fullscreen');
        if (window.HubSpotConversations) {
            window.HubSpotConversations.widget.load();
        }
        Bingo.Map.reloadAllInstancesIn(`#${el.data('primary-area-id')}`);
        el.text(showText);
    }

    el.blur();
};
